import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "AddDevice" })
export default class AddDevice extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public formData: any = {};
    public data: any = {};
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public isRegistrationCode: boolean = false;
    public validationErrors: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    public checkForm() {
        this.isSuccess ? this.submitForm() : this.validateSerialNumber();
    }

    public async validateSerialNumber() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            let result = (await Axios.post(this.routes.MyMectronicDevice_ValidateSerialNumber, this.formData, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
            this.formData.tagName = result.tagName;

            result.isRegistrationCode ? (this.isRegistrationCode = true) : (this.isRegistrationCode = false);

            this.isSuccess = true;

            GTagHelper.sendEvent("form_submit", "device_add_success");
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
                
                GTagHelper.sendEvent("form_submit", "device_add_failed");
            }
        }

        this.isLoading = false;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            let result = (await Axios.post(this.routes.MyMectronicDevice_RegisterDevice, this.formData, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

            window.location.href = window.location.href;
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }
};